<template>
  <v-container>
    <navigation></navigation>
    <div :class="$style.viewContainer">
      <div :class="$style.sidenav">
        <h4>Encounter Templates</h4>
        <ul :class="$style.templateList">
          <li
            :class="$style.listElement"
            v-for="template in encounterList"
            :key=template.id
            @click="selectTemplate(template.id)">
            <div :class="$style.title">{{ template.title }}</div>
            <div :class="$style.subtitle">{{ template.subtitle }}</div>
          </li>
        </ul>
      </div>
      <div v-if="template.title" :class="$style.draftingArea">
        <div :class="$style.titleBar">
          <span :class="$style.title">title: {{template.title}}</span>
          <span :class="$style.subtitle">subtitle: {{template.subtitle}}</span>
        </div>
        <div :class="$style.actionHeader">Encounter actions</div>
        <div
          v-for="(action, index) in template.action" :key=index
          :class="$style.action">
          <div :class="$style.priority">{{action.priority}}</div>
          <div :class="$style.actionContainer">
            {{action.title}}
          </div>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import Navigation from '@/components/Navigation.vue'

export default {
  components: {
    Navigation
  },
  data () {
    return {
      encounterList: [],
      selectedTemplate: '',
      template: {}
    }
  },
  methods: {
    async selectTemplate (id) {
      this.selectedTemplate = id
      const templateQuery = await this.axios.get(`${process.env.VUE_APP_API_BASEURL}/planDefinition/${id}`)
      this.template = templateQuery.data
    }
  },
  async created () {
    const results = await this.axios.get(`${process.env.VUE_APP_API_BASEURL}/planDefinitions`)
    this.encounterList = results.data
  }
}
</script>

<style module>
.viewContainer {

}
/* The sidebar menu */
.sidenav {
  height: 100%; /* Full-height: remove this if you want "auto" height */
  width: 15%; /* Set the width of the sidebar */
  position: relative; /* Fixed Sidebar (stay in place on scroll) */
  float: left;
  z-index: 1; /* Stay on top */
  background-color: #ffffff;
  overflow-x: hidden; /* Disable horizontal scroll */
  padding-top: 20px;
}

.templateList {
  list-style-type: none;
}

.listElement {
  cursor: pointer;
}

.listElement:hover {
  color: #28B6F5;
}

.templateList li {
  margin: 20px;
}
.listElement .title {
  width: 100%;
  font: 700 14px arial, sans-serif;
}
.listElement .subtitle {
  width: 100%;
  font: 300 12px arial, sans-serif;
}

.draftingArea {
  background-color: #EFF2F2;
  float: left;
  width: 80%;
}

.titleBar {
  background-color: #ffffff;
  border: 1px solid #888888;
  height: 70px;
  width: 80%;
  margin: 20px 30px 10px 30px;
  padding-top: 22px;
}

.titleBar span.title, .titleBar span.subtitle {
  margin-left: 15%;
  color: #888888;
}

.actionHeader {
  margin: 20px 20px 15px 30px;
  padding-bottom: 8px;
  width: 80%;
  border-bottom: 1px solid #BBBBBB;
  color: #888888;
  font: 300 18px arial, sans-serif;
}

.action {
  margin: 10px 10px 10px 30px;
  width: 80%;
}

.priority, .actionContainer {
  border: 2px solid #BBBBBB;
  border-radius: 4px;
  display: inline-block;
}

.priority {
  padding: 4px 8px 4px 8px;
  width: 28px;
}

.actionContainer {
  margin-left: 12px;
  padding: 10px 8px 10px 8px;
  width: calc(100% - 40px);
}

</style>
